import { View } from 'foundations-components/components/View';
import styled, { useTheme } from 'styled-components';
import FeatureTableBodyCell from './FeatureTableBodyCell';
import FeatureTableBodyNameCell from './FeatureTableBodyNameCell';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledRow = styled(View)(({
  theme,
  isChildFeature
}) => Object.assign({
  '&:hover': {
    backgroundColor: theme.color['fill-surface-raised']
  }
}, isChildFeature && {
  position: 'relative',
  '&::after': {
    content: '""',
    position: 'absolute',
    top: theme.space['0'],
    left: theme.space['0'],
    width: theme.space['400'],
    // Reduced indent width to 16px
    height: theme.borderWidth['100'],
    backgroundColor: theme.color['fill-surface-default'],
    zIndex: 1 // Ensure the overlay is above the border
  }
}));
const TableBodyRow = ({
  feature,
  isChildFeature,
  apiNames
}) => {
  const theme = useTheme();
  const minBlockSize = theme.space['1200'];
  return /*#__PURE__*/_jsxs(StyledRow, {
    as: "tr",
    isChildFeature: isChildFeature,
    children: [/*#__PURE__*/_jsx(FeatureTableBodyNameCell, {
      feature: feature,
      isChildFeature: isChildFeature,
      minBlockSize: minBlockSize
    }), feature.shortName === 'payments' ? /*#__PURE__*/_jsx(FeatureTableBodyCell, {
      feature: feature,
      columnApiName: apiNames[0],
      colSpan: apiNames.length,
      minBlockSize: minBlockSize
    }) : apiNames.map(apiName => /*#__PURE__*/_jsx(FeatureTableBodyCell, {
      feature: feature,
      columnApiName: apiName,
      colSpan: 1,
      minBlockSize: minBlockSize
    }, apiName))]
  }, feature.shortName);
};
export default TableBodyRow;